import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useLang } from "@/i18n";

export default function PaymentCancel() {
  const { tr } = useLang();
  return (
    <div data-testid="page-payment-cancel" className="bg-white text-[#0a0a0a] min-h-screen flex items-center pt-32 pb-24">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12 w-full">
        <div className="max-w-xl border border-[#e4e4e7] bg-[#f4f4f5] p-12 md:p-16">
          <XCircle size={40} className="text-[#FF4D00]" />
          <h1 className="font-display text-4xl md:text-5xl tracking-tighter mt-8 mb-6">
            {tr({ it: "Pagamento annullato.", en: "Payment cancelled." })}
          </h1>
          <p className="font-body text-[#3f3f46] leading-relaxed mb-10">
            {tr({
              it: "Nessun addebito è stato effettuato. Puoi riprovare quando vuoi oppure scegliere il bonifico bancario come metodo per la cauzione.",
              en: "No charge was made. You can try again anytime, or choose bank transfer for the deposit.",
            })}
          </p>
          <div className="flex flex-wrap gap-4">
            <Link to="/prova-a-casa" className="btn-primary" data-testid="cancel-retry-link">
              {tr({ it: "Riprova", en: "Try again" })} →
            </Link>
            <Link to="/contatti" className="btn-ghost">
              {tr({ it: "Contattaci", en: "Contact us" })}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
